import {_import_} from './_import.js';
const url = 'singleResult'; // 模块文件夹路径
const result = _import_(url + '/index');

export default [
  {
    path: '/singleResult',
    name: 'singleResult',
    meta: {
      title: {title: '测评结果'},
      needLogin: true
    },
    component: result
  }
];



// WEBPACK FOOTER //
// ./src/router/singleResult.js